import { render, staticRenderFns } from "./ProminentButton.vue?vue&type=template&id=e6914866&scoped=true"
import script from "./ProminentButton.vue?vue&type=script&lang=js"
export * from "./ProminentButton.vue?vue&type=script&lang=js"
import style0 from "./ProminentButton.vue?vue&type=style&index=0&id=e6914866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6914866",
  null
  
)

export default component.exports